// extracted by mini-css-extract-plugin
export default {"container":"mOVko4qQRG","message":"ekpvV8xj0w"};